/* Copyright (c) 2020-present CloudIO Inc */

import useConstant from './useConstant';

let counter = 0;

export default function useId(id?: string) {
  return useConstant(() => id || `i${++counter}`);
}
